"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BLFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_28)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_28`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.03935 14.0183C5.03935 14.0183 4.40497 17.1011 3.68426 16.8526C2.939 16.6042 2.45409 15.5362 2.45409 15.5362L1.43514 17.0267C1.43514 17.0267 4.11444 17.6218 4.31304 17.4105C4.39865 17.3305 4.88918 16.3509 5.03865 15.5825V14.0183H5.03935ZM1.1004 18.2688C1.1004 18.2688 0.92637 19.6849 1.02602 19.859C1.11304 20.0204 3.79655 20.6541 3.79655 20.6541C3.79655 20.6541 2.04497 21.8091 1.70953 22.0955L0.442159 19.9958L0.392334 18.2688H1.1004ZM1.89549 6.64142C1.89549 6.64142 4.67795 9.56072 4.72777 9.8344C4.7776 10.0955 4.42953 10.0583 4.42953 10.0583C4.42953 10.0583 1.28637 7.42458 0.926369 7.17616C0.553738 6.92703 1.89549 6.64142 1.89549 6.64142Z",
					fill: "#E6BC00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0.976164 7.34947C0.976164 7.34947 2.16845 7.29965 2.14388 6.54176C2.11932 5.79649 1.36143 5.49825 0.802129 5.67228C0.242831 5.83368 -0.812608 6.61614 -0.154362 8.13193C0.503883 9.63509 1.48564 10.1944 1.68423 11.4863C1.68423 11.4863 1.30108 12.1782 0.34248 11.5109C-0.843485 10.6849 -0.0926075 8.82737 -0.390152 8.35579C-0.688397 7.85895 -3.26384 5.62456 -3.26384 5.62456C-3.26384 5.62456 -5.38594 8.38737 -4.52699 10.8821C-3.33752 14.3354 -0.896117 13.1263 0.00704098 13.4618C0.00704098 13.4618 -2.94945 17.8098 -3.47156 18.1698C-3.47156 18.1698 -1.78173 18.7537 -0.117169 16.8533C-0.117169 16.8533 0.292655 17.5368 0.379673 18.2695H1.10037C1.43581 16.4309 4.71511 13.76 4.60353 12.4926C4.47932 11.0014 1.1502 9.02667 0.976164 7.34947Z",
					fill: "#ADADAD"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.2049 14.1242C19.2049 14.1242 19.8336 17.1018 20.5543 16.8533C21.2996 16.6049 21.7845 15.5369 21.7845 15.5369L22.8035 17.0274C22.8035 17.0274 20.207 17.6225 20.0084 17.4112C19.9235 17.3312 19.3543 16.4435 19.2 15.6807L19.2049 14.1242ZM23.1382 18.2688C23.1382 18.2688 23.3122 19.6849 23.2126 19.859C23.1256 20.0204 20.4421 20.6541 20.4421 20.6541C20.4421 20.6541 22.1936 21.8091 22.5291 22.0955L23.7964 19.9958L23.8463 18.2688H23.1382ZM22.3431 6.64142C22.3431 6.64142 19.5607 9.56072 19.5108 9.8344C19.461 10.0955 19.8091 10.0583 19.8091 10.0583C19.8091 10.0583 22.9522 7.42458 23.3122 7.17616C23.6729 6.92703 22.3431 6.64142 22.3431 6.64142Z",
					fill: "#E6BC00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.03931 6.1095H19.2V16.3172C19.2 17.4442 18.52 17.8183 17.6625 18.5523L14.44 21.3179C13.1593 22.4141 11.0779 22.4105 9.80352 21.3179L6.57475 18.5509C5.72703 17.8246 5.03931 17.4484 5.03931 16.3179V6.1095Z",
					fill: "#125ECC"
				}),
				/* @__PURE__ */ n("path", {
					d: "M8.07373 10.3656C7.51513 10.3656 7.0625 9.91298 7.0625 9.35438C7.0625 8.79579 7.51513 8.34316 8.07373 8.34316C8.63232 8.34316 9.08496 8.79579 9.08496 9.35438C9.08496 9.91298 8.63232 10.3656 8.07373 10.3656ZM12.1193 10.1551C11.5607 10.1551 11.1081 9.70245 11.1081 9.14386C11.1081 8.58526 11.5607 8.13263 12.1193 8.13263C12.6779 8.13263 13.1306 8.58526 13.1306 9.14386C13.1306 9.70245 12.6779 10.1551 12.1193 10.1551ZM16.165 10.3656C15.6064 10.3656 15.1537 9.91298 15.1537 9.35438C15.1537 8.79579 15.6064 8.34316 16.165 8.34316C16.7236 8.34316 17.1762 8.79579 17.1762 9.35438C17.1762 9.91298 16.7236 10.3656 16.165 10.3656ZM9.08496 19.2582C8.52636 19.2582 8.07373 18.8056 8.07373 18.247C8.07373 17.6884 8.52636 17.2358 9.08496 17.2358C9.64355 17.2358 10.0962 17.6884 10.0962 18.247C10.0969 18.8056 9.64355 19.2582 9.08496 19.2582ZM12.1193 20.2702C11.5607 20.2702 11.1081 19.8175 11.1081 19.2589C11.1081 18.7003 11.5607 18.2477 12.1193 18.2477C12.6779 18.2477 13.1306 18.7003 13.1306 19.2589C13.1306 19.8168 12.6779 20.2702 12.1193 20.2702ZM15.1537 19.2582C14.5951 19.2582 14.1425 18.8056 14.1425 18.247C14.1425 17.6884 14.5951 17.2358 15.1537 17.2358C15.7123 17.2358 16.165 17.6884 16.165 18.247C16.165 18.8056 15.7123 19.2582 15.1537 19.2582Z",
					fill: "#FFE600"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.03931 12.306H19.2V16.3516H5.03931V12.306Z",
					fill: "#D60537"
				}),
				/* @__PURE__ */ n("path", {
					d: "M4.02808 3.07507C4.02808 3.07507 8.07369 2.06384 12.12 2.06384C16.1663 2.06384 20.2119 3.07507 20.2119 3.07507L19.2007 7.12068C19.2007 7.12068 15.6604 6.10946 12.1207 6.10946C8.58106 6.10946 5.04071 7.12068 5.04071 7.12068L4.02808 3.07507Z",
					fill: "#EACE00"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.1193 5.09826C11.5607 5.09826 11.1081 4.64563 11.1081 4.08703C11.1081 3.52844 11.5607 3.07581 12.1193 3.07581C12.6779 3.07581 13.1306 3.52844 13.1306 4.08703C13.1306 4.64563 12.6779 5.09826 12.1193 5.09826ZM16.165 5.44914C15.6064 5.44914 15.1537 4.99651 15.1537 4.43791C15.1537 3.87931 15.6064 3.42668 16.165 3.42668C16.7236 3.42668 17.1762 3.87931 17.1762 4.43791C17.1762 4.99651 16.7236 5.44914 16.165 5.44914ZM8.07373 5.44914C7.51513 5.44914 7.0625 4.99651 7.0625 4.43791C7.0625 3.87931 7.51513 3.42668 8.07373 3.42668C8.63232 3.42668 9.08496 3.87931 9.08496 4.43791C9.08496 4.99651 8.63232 5.44914 8.07373 5.44914Z",
					fill: "#7A6920"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.6196 12.4926C19.508 13.76 22.7873 16.4309 23.1228 18.2695H23.8435C23.9305 17.5368 24.3403 16.8533 24.3403 16.8533C26.0049 18.7544 27.6947 18.1698 27.6947 18.1698C27.1726 17.8098 24.2161 13.4618 24.2161 13.4618C25.12 13.1263 27.5614 14.3354 28.7501 10.8821C29.6091 8.38737 27.487 5.62456 27.487 5.62456C27.487 5.62456 24.9115 7.85895 24.6133 8.35579C24.315 8.82807 25.0666 10.6856 23.8807 11.5109C22.9221 12.1782 22.5389 11.4863 22.5389 11.4863C22.7375 10.1944 23.7193 9.63509 24.3775 8.13193C25.0357 6.61614 23.9803 5.83368 23.421 5.67228C22.8617 5.49825 22.1045 5.79649 22.0793 6.54176C22.0547 7.29965 23.247 7.34947 23.247 7.34947C23.0729 9.02667 19.7438 11.0014 19.6196 12.4926Z",
					fill: "#ADADAD"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.1193 15.5172C12.7755 15.5172 13.3074 14.9853 13.3074 14.3291C13.3074 13.673 12.7755 13.1411 12.1193 13.1411C11.4632 13.1411 10.9313 13.673 10.9313 14.3291C10.9313 14.9853 11.4632 15.5172 12.1193 15.5172Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_28`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BLFlag };
